module.exports = __webpack_public_path__ + "static/media/ReportIcon.3fc8b52a.svg";